import React from 'react'

const Deactivated = () => {
  return (
    <div>Deactivated</div>
  )
}

export default Deactivated